export const SHOW_SEARCH = "SHOW_SEARCH";
export const SHOW_BROWSE = "SHOW_BROWSE";
export const SHOW_SETTINGS = "SHOW_SETTINGS";
export const HIDE_SETTINGS = "HIDE_SETTINGS";

export const ADAPT_DISPLAY_OPTIONS = "ADAPT_DISPLAY_OPTIONS";
export const ADAPT_SEARCH_OPTIONS = "ADAPT_SEARCH_OPTIONS";
export const ADAPT_COPY_OPTIONS = "ADAPT_COPY_OPTIONS";
